// This is needed to share the same imgix props during pre-fetching in the
// PDPDesktopHeroGalleryUI and PDPDesktopThumbnails components.
export const getMainImageImgixPropsForPhoto = (photo, enableCrops) => ({
  src: photo.src,
  type: photo.type,
  crops: photo.cropData || {},
  enableCrops,
});

const configurationThumbProps = {
  bg: 'ffffff',
  fit: 'clip',
  height: '32px',
  trim: 'color',
  trimPad: 50,
  trimTol: 10,
  width: '38px',
};

export const getThumbnailImageImgixPropsForPhoto = ({ src, type }) => ({
  src,
  width: 44,
  height: 38,
  ...(type === 'configuration' || type === 'cylindo'
    ? configurationThumbProps
    : null),
});
